<template lang="pug">
    //- a rendering issue with nested elements, workaround with inner div below
    div(class="test")
        div(class="stock-card-item stn-sdw" style="height:445px;")
            div(v-if="show" class="stock-card-item-title")
                Ticker(:stockId="stock.stock_id")
                div(:title="stock.name" class="" style="") {{ stock.name }}
                div(class="text-right" style="height:20px; border:0px solid;")
                    WatchlistAddTo(:stocks="[stock]" :page="'home'" ref="watchlistAddToElement")

            div(class="stock-card-item-content")

                div(class="item-data" style="display: flex; padding: 24px 0")

                    div(style="padding-right: 12px; width: 100%;")
                        div(v-if="show" class="" style="color:rgba(47, 60, 61, 1); border:0px solid; font-size:12px; font-weight:600;padding-bottom: 8px") {{ $t(stock.sector_name) }}
                        div(style="line-height:1.4; display:-webkit-box; webkit-line-clamp:4; -webkit-box-orient:vertical; overflow:hidden; text-overflow:ellipsis; border:0px solid;")
                            span(v-if="$i18n.locale === 'en'") {{ companyData.description }}
                            span(v-else-if="$i18n.locale === 'sv'") {{ companyData.description_sv }}

                    div(v-if="show")
                        div(style="border:1px solid lightgrey; border-radius: 6px; display:flex; width: 100px; height: 100px; align-items: center;")
                            img(:src="logoURL" alt="image" onerror="this.style.display='none'" style="max-width: 90%; margin: 0 auto;")


            div(class="item-stock-data")
                div(v-if="show" style="font-weight:600; font-size:12px; border:0px solid;") {{ $t('market_cap') }} {{ format(marketCap) }} EURO {{ $t('millions') }}

                div(v-if="show" class="pl-1 mt-2" style="width:100%; border:0 solid;")
                    div(ref="chartPriceBlock" style="overflow:hidden; height:170px; border:0px solid red;")
                        div(v-if="!showChartPrice" class="fade-out-and-fade-in" style="width:100%; height:100%; background-color:rgb(245, 245, 245); border:1px solid rgb(200, 200, 200);")
                        ChartPrice(v-else :widthStockCard="widthChartBlock" :prices="stock.prices" :stock_id='stock.stock_id' :company_id='stock.company_id' :legendView="false" :single="true" :toolbar="false" :grids="false" :showrightSideBarLine="false" page="stockCards" ref="chartPriceElement" style=" border:0px solid black;")

                div(v-if="show && stock.performancemtd !== undefined" class="ml-1 mt-4 mb-2" style="font-size:12px; font-weight:600; border:0px solid;") {{ $t('theme_performance_mtd') }} {{ stock.performancemtd !== null ? `${stock.performancemtd}%` : 'Not set' }}
                div(v-else-if="show && stock.date_report !== undefined" class="ml-1 mt-4 mb-2" style="font-size:12px; font-weight:600; border:0px solid;") Report date {{ stock.date_report !== null ? stock.date_report : 'Not set' }}
                div(v-else-if="show && stock.transaction_date !== undefined" class="ml-1 mt-4 mb-2" style="font-size:12px; font-weight:600; border:0px solid;") Transactions date {{ stock.transaction_date !== null ? stock.transaction_date : 'Not set' }}
                div(v-else-if="show && stock.yield !== undefined" class="ml-1 mt-4 mb-2" style="font-size:12px; font-weight:600; border:0px solid;") {{ $t('yield') }} {{ stock.yield !== null ? stock.yield : 'Not set' }}
</template>

<script>
import Ticker from './../../components/Ticker.vue';
import WatchlistAddTo from './../../components/WatchlistAddTo';
import ChartPrice from './../../components/ChartPrice.vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default {
    name: 'StockCard',
    props: {
        stock: Object,
        theme_id: {
            type: Number,
            default: 0
        },
        resizeBetweenFix: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Ticker,
        WatchlistAddTo,
        ChartPrice
    },
    data() {
        return {
            widthChartBlock: 0,
            show: false,
            showChartPrice: false,
            rates: [
                { currency: 'EUR', rate: 1.00 },
                { currency: 'SEK', rate: 11.10 },
                { currency: 'NOK', rate: 10.69 },
                { currency: 'DKK', rate: 7.44 },
            ]
        };
    },
    mounted() {
        setTimeout(() => {
            this.show = true;
        }, 50);

        setTimeout(() => {
            this.setDimentionsOfChartBlock();
            window.addEventListener('resize', this.setDimentionsOfChartBlock);
            this.showChartPrice = true;
        }, 1000);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setDimentionsOfChartBlock);
    },
    computed: {
        ...mapGetters([
            'getAllStocks',
            'getAllCompanies',
            'getCachedCompaniesAndReports',
            'getCompanyReports',
            'getRecentInsiders'
        ]),
        user_id() {
            return JSON.parse(localStorage.getItem('user')).user_id;
        },
        user() {
            return JSON.parse(localStorage.getItem('user'));
        },
        company_id() {
            return this.getAllStocks.find((s) => s.stock_id === this.stock.stock_id).company_id;
        },
        company() {
            return this.getCachedCompaniesAndReports.find((cr) => cr.company_id === this.company_id);
        },
        marketCap() {
            const orderedCompanyReports = _.orderBy(this.company.CompanyReports, ['period'], ['asc']);
            const latestCompanyReport = orderedCompanyReports[orderedCompanyReports.length - 1];
            let totalnumberofshares = 0;
            let price = 0;
            let currency = '';

            try {
                totalnumberofshares = Number(latestCompanyReport.totalnumberofshares);
            } catch (error) {
                console.log(error.message);
            }

            try {
                price = Number(latestCompanyReport.price);
            } catch (error) {
                console.log(error.message);
            }

            try {
                currency = latestCompanyReport.currency;
            } catch (error) {
                console.log(error.message);
            }

            const dividedBy = currency !== '' ? this.currencyRate(currency) * 1000000 : 0;
            const marketCap = (price * totalnumberofshares) / dividedBy;

            return marketCap.toFixed(0);
        },
        companyData() {
            const c = this.getAllCompanies.get(this.company_id);
            if (c) {
                return c;
            }

            console.log(`${this.company_id} not found in mapCompanies MAP of VUEX, expect bugs`);

            return null;
        },
        logoURL() {
            const logo_url = `/images/logos/senofidk/${this.stock.company_id}.png`;

            return logo_url;
        }
    },
    watch: {
        resizeBetweenFix() {
            if(this.resizeBetweenFix) {
                try {
                    this.widthChartBlock = this.stockCardBlockWidth();
                    this.$refs.chartPriceElement.chartWidth = this.widthChartBlock;
                } catch (error) {
                    console.log(error.message);
                }
            }
        }
    },
    methods: {
        setDimentionsOfChartBlock() {
            this.widthChartBlock = this.stockCardBlockWidth();
        },
        stockCardBlockWidth() {
            try {
                return this.$refs.chartPriceBlock.offsetWidth;
            } catch(error) {
                return 250;
            }
        },
        currencyRate(currency) {
            return this.rates.find((r) => r.currency === currency).rate;
        },
        format(x) {
            return new Intl.NumberFormat('sv-SE').format(x);
        }
    }
}
</script>

<style scoped>
.stock-card-item {
    background-color:#fff;
    border: 0px solid green;
    border-radius: 8px;
    margin:8px;
    padding: 12px;
}

.stock-card-item-title {
    align-items: center;
    display: flex;
    justify-content: space-between;
}

.stock-card-item-title div:nth-child(2) {
    overflow:hidden;
    font-size: 14px;
    font-weight: 600;
    text-transform: capitalize;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 50%;
    border: 0px solid;
    text-align: left
}

.fade-out-and-fade-in {
    animation: fade-out-fade-in 1.2s infinite;
}

@keyframes fade-out-fade-in {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.4;
    }
    100% {
        opacity: 1;
    }
}
</style>
